import React, { Component } from "react";
import FlexText from "../../flexText";
import Anchor from "../../pageElements/anchor";
import Styles from "./styles/topSignStyles";

class TopSignNav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      factoid: [],
      config: [],
      nodeid: []
    };
  }

  render() {
    if (this.state.config) {
      console.log(" ->", this.props);
      return (
        <div
          style={{
            ...Styles.signStyles,
            ...this.props.style,
            color: this.props.blockStyle.field_text_color_font[0].field_color_1
          }}
        >
          <nav className="3ButtonNav" style={{ width: "100%" }}>
            <ul style={Styles.ulStyle}>
              {typeof this.props.links[0] !== "undefined" ? (
                <li style={Styles.liStyle}>
                  <a
                    id={"item" + this.props.data[0].item_id + "_sign1"}
                    className={this.props.blockStyle.field_link_colors.name}
                    tabIndex="0"
                    style={Styles.linkStyle}
                    href={this.props.links[0].url}
                  >
                    {this.props.links[0].title}
                  </a>
                </li>
              ) : null}
              {typeof this.props.links[1] !== "undefined" ? (
                <li style={Styles.liStyle}>
                  <a
                    id={"item" + this.props.data[0].item_id + "_sign2"}
                    className={this.props.blockStyle.field_link_colors.name}
                    tabIndex="0"
                    style={Styles.linkStyle}
                    href={this.props.links[1].url}
                  >
                    {this.props.links[1].title}
                  </a>
                </li>
              ) : null}
              {typeof this.props.links[2] !== "undefined" ? (
                <li style={Styles.liStyleRight}>
                  <a
                    id={"item" + this.props.data[0].item_id + "_sign3"}
                    className={this.props.blockStyle.field_link_colors.name}
                    tabIndex="0"
                    style={Styles.linkStyle}
                    href={this.props.links[2].url}
                  >
                    {this.props.links[2].title}
                  </a>
                </li>
              ) : null}
            </ul>
          </nav>
          <div style={{ margin: "24px" }}>
            <Anchor
              id={"item" + this.props.data[0].item_id + "_sign4"}
              className={
                this.props.blockStyle.field_link_colors.name + " signLink"
              }
              link={this.props.data[0].field_link_1}
            >
              <FlexText
                max="32"
                min="32"
                pert=".25"
                classes="flexText"
                tag="h2"
                styles={{
                  fontFamily: "Oswald",
                  fontSize: "32px",
                  textAlign: "left",
                  display: "block",
                  width: "100%",
                  margin: "24px 0 16px"
                }}
              >
                {this.props.data[0].field_text_1}
              </FlexText>
              <FlexText
                max="16"
                min="16"
                pert=".25"
                classes="flexText"
                tag="div"
                styles={{
                  fontFamily: "Roboto, sans-serif"
                }}
              >
                {this.props.data[0].field_longtext_1}
              </FlexText>
            </Anchor>
          </div>
          <div
            style={{
              height: "60px",
              width: "30px",
              backgroundColor: "transparent",
              position: "absolute",
              right: "8px",
              bottom: "-5px",
              borderRight: "10px solid rgb(255, 255, 255)",
              transform: "rotate(45deg)"
            }}
          ></div>
        </div>
      );
    } else {
      return <p>Loading...</p>;
    }
  }
}

export default TopSignNav;
